<template>
  <div class="lambda-dao-container content-container">
    <div class="title-section">
      <h1>LambdaDAO</h1>
      <h2>{{ $t("dao.t1") }}</h2>
    </div>

    <div class="content-section">
      <div class="img-item">
        <img src="../../assets/LambDao/cube.png">
      </div>

      <div class="intro-item">
        <p class="title">
          {{ $t("dao.s1.t1") }}
        </p>
        <p class="intro">
          {{ $t("dao.s1.t2") }}
        </p>
        <myButton
          custom-type="link"
          href="https://lambdastorage.zendesk.com/hc/zh-cn/articles/360006363097-Lambda-%E9%AA%8C%E8%AF%81%E8%8A%82%E7%82%B9%E4%BB%8B%E7%BB%8D"
        >
          {{ $t("dao.s1.btn") }}
        </myButton>
      </div>
    </div>

    <div class="content-section">
      <div class="img-item">
        <img src="../../assets/LambDao/vr.png">
      </div>

      <div class="intro-item">
        <p class="title">
          {{ $t("dao.s2.t1") }}
        </p>
        <p class="intro">
          {{ $t("dao.s2.t2") }}
        </p>
        <myButton
          custom-type="link"
          href="https://lambdastorage.zendesk.com/hc/zh-cn/articles/360006395478-Lambda-%E5%AD%98%E5%82%A8%E7%9F%BF%E5%B7%A5%E4%BB%8B%E7%BB%8D"
        >
          {{ $t("dao.s2.btn") }}
        </myButton>
      </div>
    </div>

    <div class="content-section">
      <div class="img-item">
        <img src="../../assets/LambDao/glass.png">
      </div>

      <div class="intro-item">
        <p class="title">
          {{ $t("dao.s3.t1") }}
        </p>
        <p class="intro">
          {{ $t("dao.s3.t2") }}
        </p>

        <p class="subtitle">
          {{ $t("dao.s3.t3") }}
        </p>
        <ul class="list">
          <li>
            <span class="dot">•</span>
            {{ $t("dao.s3.i1") }}
          </li>
          <li>
            <span class="dot">•</span>
            {{ $t("dao.s3.i2") }}
          </li>
          <li>
            <span class="dot">•</span>
            {{ $t("dao.s3.i3") }}
          </li>
          <li>
            <span class="dot">•</span>
            {{ $t("dao.s3.i4") }}
          </li>
        </ul>

        <myButton
          custom-type="link"
          href="https://lambdastorage.zendesk.com/hc/zh-cn/articles/360006395498-Lambda-%E5%AD%98%E5%82%A8%E5%81%9A%E5%B8%82%E5%95%86%E4%BB%8B%E7%BB%8D"
        >
          {{ $t("dao.s3.btn") }}
        </myButton>
      </div>
    </div>

    <div class="content-section">
      <div class="img-item">
        <img src="../../assets/LambDao/global.png">
      </div>

      <div class="intro-item">
        <p class="title">
          {{ $t("dao.s4.t1") }}
        </p>
        <p class="intro">
          {{ $t("dao.s4.t2") }}
        </p>
        <myButton
          custom-type="link"
          href="https://lambdastorage.zendesk.com/hc/zh-cn/articles/360006363117-Lambda-%E7%9F%BF%E5%B7%A5%E6%8A%80%E6%9C%AF%E5%B0%8F%E7%BB%84"
        >
          {{ $t("dao.s4.btn") }}
        </myButton>
      </div>
    </div>

    <div class="content-section">
      <div class="img-item">
        <img src="../../assets/LambDao/glove.png">
      </div>

      <div class="intro-item">
        <p class="title">
          {{ $t("dao.s5.t1") }}
        </p>
        <p class="intro">
          {{ $t("dao.s5.t2") }}
        </p>
        <myButton
          custom-type="router"
          to="/developer"
        >
          {{
            $t("dao.s5.btn")
          }}
        </myButton>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    myButton: () => import("@/components/MyButton.vue")
  }
};
</script>

<style lang="less" scoped>
@media (min-width: 501px) {
  .lambda-dao-container {
    .title-section {
      padding-top: 110px;
      margin-bottom: 40px;
      h1 {
        text-align: center;
        font-size: 34px;
        font-family: PingFangHK-Medium, PingFangHK;
        font-weight: 500;
        color: rgba(38, 38, 38, 1);
        line-height: 48px;
      }
      h2 {
        text-align: center;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(38, 38, 38, 1);
        line-height: 28px;
      }
    }
    .content-section {
      max-width: 1000px;
      padding: 30px;
      margin-bottom: 40px !important;
      background: #ffffff;
      box-shadow: 1px 3px 21px 0px rgba(230, 228, 254, 0.36);
      border-radius: 5px;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      .img-item {
        margin-right: 30px;
      }
      .intro-item {
        .title {
          font-size: 24px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(38, 38, 38, 1);
          line-height: 33px;
        }
        .intro {
          margin-bottom: 28px;
          font-size: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(38, 38, 38, 1);
          line-height: 28px;
        }
        .subtitle {
          margin-top: 20px;
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(63, 74, 225, 1);
          line-height: 28px;
        }
        .list {
          margin: 0;
          padding: 0;
          list-style: none;
          li {
            margin-bottom: 20px;
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(38, 38, 38, 1);
            line-height: 25px;
          }
          .dot {
            margin-right: 5px;
            color: #3f4ae1;
          }
        }
      }
    }
  }
}

@media (max-width: 500px) {
  .lambda-dao-container {
    .title-section {
      padding-top: 110px;
      margin-bottom: 40px;
      h1 {
        text-align: center;
        font-size: 30px;
        font-family: PingFangHK-Medium, PingFangHK;
        font-weight: 500;
        color: rgba(38, 38, 38, 1);
        line-height: 42px;
      }
      h2 {
        text-align: center;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(38, 38, 38, 1);
        line-height: 28px;
      }
    }
    .content-section {
      padding: 30px;
      margin-bottom: 40px !important;
      background: #ffffff;
      box-shadow: 1px 3px 21px 0px rgba(230, 228, 254, 0.36);
      border-radius: 5px;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      flex-wrap: wrap;
      .img-item {
        margin-right: 30px;
      }
      .intro-item {
        .title {
          margin-top: 20px;
          font-size: 24px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(38, 38, 38, 1);
          line-height: 33px;
        }
        .intro {
          margin-bottom: 28px;
          font-size: 15px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(38, 38, 38, 1);
          line-height: 21px;
        }
        .subtitle {
          margin-top: 20px;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(63, 74, 225, 1);
          line-height: 22px;
        }
        .list {
          margin: 0;
          padding: 0;
          list-style: none;
          li {
            margin-bottom: 20px;
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(38, 38, 38, 1);
            line-height: 21px;
          }
          .dot {
            margin-right: 5px;
            color: #3f4ae1;
          }
        }
      }
    }
  }
}
</style>
